import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["onClick"];
import TeamLogo from "@/modules/team/components/TeamLogo.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'TeamLink',
  props: {
    entity: null,
    orientation: {
      default: 'left'
    },
    disabled: {
      type: Boolean
    },
    short: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const onClick = event => {
      if (!props.disabled) {
        router.push({
          name: 'teams.show',
          params: {
            id: props.entity.id
          }
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex items-center", {
          'flex-row-reverse': __props.orientation === 'right'
        }])
      }, [_createVNode(TeamLogo, {
        team: __props.entity,
        class: _normalizeClass(["h-8 w-8", {
          'mr-2': __props.orientation === 'left',
          'ml-2': __props.orientation === 'right'
        }])
      }, null, 8, ["team", "class"]), _createElementVNode("a", {
        href: "#",
        class: _normalizeClass(__props.entity.user ? 'text-green-600' : 'text-sky-600'),
        onClick: _withModifiers(onClick, ["prevent", "stop"])
      }, _toDisplayString(__props.short ? __props.entity.shortName : __props.entity.name), 11, _hoisted_1)], 2);
    };
  }
});